/** Поиск по проекту и выгрузка. */

import type { SearchResponseDto } from '@project-os/contracts';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './client';

export const searchKeys = {
  query: (projectId: string, q: string) => ['projects', projectId, 'search', q] as const,
};

/** Минимальная длина запроса: на одну букву искать бессмысленно. */
export const MIN_SEARCH_LENGTH = 2;

export function useProjectSearch(projectId: string | undefined, query: string) {
  const enabled = Boolean(projectId) && query.trim().length >= MIN_SEARCH_LENGTH;

  return useQuery({
    queryKey: searchKeys.query(projectId ?? '', query),
    queryFn: ({ signal }) =>
      apiRequest<SearchResponseDto>(
        `/projects/${projectId}/search?q=${encodeURIComponent(query)}&limit=6`,
        { signal },
      ),
    enabled,
    // Выдача поиска живёт недолго: результат зависит от того, что успели
    // изменить соседи.
    staleTime: 10_000,
  });
}

/**
 * Адрес выгрузки.
 *
 * Экспорт скачивается обычной ссылкой, а не fetch: браузер сам сохранит файл
 * с именем из заголовка, и содержимое не окажется в памяти вкладки.
 */
export function exportUrl(projectId: string, format: 'json' | 'markdown'): string {
  return `/api/projects/${projectId}/export?format=${format}`;
}
